import axios from 'axios';
import { apiBaseUrl } from '../config';

function authHeaders(token) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// ---------- Public ----------

export const listBlogs = (params = {}, userToken) =>
  axios.get(`${apiBaseUrl}/blogs`, {
    params,
    headers: authHeaders(userToken),
    withCredentials: true
  });

export const getBlogBySlug = (slug, userToken) =>
  axios.get(`${apiBaseUrl}/blogs/${encodeURIComponent(slug)}`, {
    headers: authHeaders(userToken),
    withCredentials: true
  });

export const getBlogCategories = () =>
  axios.get(`${apiBaseUrl}/blogs/categories`, { withCredentials: true });

export const getBlogTags = () =>
  axios.get(`${apiBaseUrl}/blogs/tags`, { withCredentials: true });

// ---------- Admin ----------

export const adminListBlogs = (adminToken, params = {}) =>
  axios.get(`${apiBaseUrl}/admin/blog/all`, {
    params,
    headers: authHeaders(adminToken),
    withCredentials: true
  });

export const adminGetBlog = (adminToken, id) =>
  axios.get(`${apiBaseUrl}/admin/blog/${id}`, {
    headers: authHeaders(adminToken),
    withCredentials: true
  });

export const adminCreateBlog = (adminToken, data) =>
  axios.post(`${apiBaseUrl}/admin/blog`, data, {
    headers: authHeaders(adminToken),
    withCredentials: true
  });

export const adminUpdateBlog = (adminToken, id, data) =>
  axios.put(`${apiBaseUrl}/admin/blog/${id}`, data, {
    headers: authHeaders(adminToken),
    withCredentials: true
  });

export const adminDeleteBlog = (adminToken, id) =>
  axios.delete(`${apiBaseUrl}/admin/blog/${id}`, {
    headers: authHeaders(adminToken),
    withCredentials: true
  });

export const adminUploadBlogImage = (adminToken, file, onProgress, acl = 'public-read') => {
  const form = new FormData();
  form.append('image', file);
  const qs = new URLSearchParams({ acl }).toString();
  return axios.post(`${apiBaseUrl}/admin/blog/uploadimage?${qs}`, form, {
    headers: {
      ...authHeaders(adminToken),
      'Content-Type': 'multipart/form-data'
    },
    withCredentials: true,
    onUploadProgress: onProgress
  });
};
